import { Storage } from "aws-amplify";
import { ProductLibProcessJob } from "../API";
import { fetchActiveProcessJobsByJobType, JobType } from "./job";

// Fetch active Product Knowledge jobs (jobType = PRODUCT_KNOWLEDGE and isActive = 'Y')
export const fetchActiveProductKnowledgeJobs = async (): Promise<ProductLibProcessJob[]> => {
  return fetchActiveProcessJobsByJobType(JobType.PRODUCT_KNOWLEDGE);
};

// Download Product Knowledge data file by jobId and brand
export const downloadProductKnowledgeData = async (
  jobId: string,
  brand: string
): Promise<any> => {
  const path = `knowledge/${jobId}/${brand}/data.json`;
  const result: any = await Storage.get(path, {
    level: "public",
    download: true,
  });

  // Parse JSON content from the downloaded blob
  const blob = result.Body as Blob;
  const text = await blob.text();
  return JSON.parse(text);
};
